import RichTextPropertyEditor from "../../../../components/RichTextPropertyEditor";

const Description = ({ handleDescriptionOnChange, value }: any) => {
  return (
    <div>
      <h2 className="mb-2 text-secondaryMidLight">Description</h2>
      <RichTextPropertyEditor
        value={value ?? ""}
        onChange={handleDescriptionOnChange}
      />
    </div>
  );
};

export { Description };
